var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 285,
    viewBox: "0 0 337 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.924 259C259.162 259 316.913 248.255 316.913 235C316.913 221.745 259.162 211 187.924 211C116.685 211 58.9346 221.745 58.9346 235C58.9346 248.255 116.685 259 187.924 259Z",
    fill: "#D2D2D2",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.515 182.253L109.64 211.053H105.092L111.967 182.253H116.515Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.037 182.253H109.322V177.798H227.037V182.253Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.282 198.387H111.332V193.932H134.282V198.387Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.715 152.935L207.874 177.798H201.649L196.489 152.935H202.715Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.983 152.935L118.142 177.798H111.916L106.757 152.935H112.983Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.927 182.253H109.322V177.798H136.927V182.253Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.548 169.142L101.471 173.598H107.698L106.773 169.142H100.548Z",
    fill: "#CFCFCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.773 169.142L107.698 173.598H212.469L211.545 169.142H106.773Z",
    fill: "#DEDEDE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8675 161.039L99.7904 165.493H106.017L105.093 161.039H98.8675Z",
    fill: "#CFCFCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.092 161.039L106.017 165.493H210.789L209.864 161.039H105.092Z",
    fill: "#DEDEDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.412 152.935L104.334 157.39H98.1096L97.1867 152.935H103.412Z",
    fill: "#CFCFCF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.181 152.935L209.106 157.39H104.335L103.412 152.935H208.181Z",
    fill: "#DEDEDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.282 182.253L141.157 211.053H136.609L129.735 182.253H134.282Z",
    fill: "#CFCFCF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.572 182.253L199.698 211.053H195.15L202.025 182.253H206.572Z",
    fill: "#CFCFCF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.34 198.387H201.389V193.932H224.34V198.387Z",
    fill: "#DEDEDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.34 182.253L231.215 211.053H226.667L219.792 182.253H224.34Z",
    fill: "#CFCFCF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.492 108.805C255.492 117.148 249.437 121.803 241.551 121.803C233.665 121.803 227.61 117.148 227.61 108.805C227.61 91.2378 236.508 70.9858 241.551 70.9858C246.594 70.9858 255.492 91.2378 255.492 108.805Z",
    fill: "#CFCFCF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.551 96.3945V134.905",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241.718 116.795L246.652 112.358",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.138 108.34L237.1 104.709",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241.794 102.653L244.876 99.8809",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8659 171.924L89.8522 211.195H63.3867L60.3734 171.924C60.2783 170.694 61.3617 169.649 62.7318 169.649H90.5073C91.8774 169.649 92.961 170.694 92.8659 171.924Z",
    fill: "#E1E1E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6197 178.506V204.99",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0076 178.506L83.9605 204.99",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2317 178.506L69.2788 204.99",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9969 172.118H59.1299V170.453C59.1299 168.947 60.4865 167.727 62.1601 167.727H90.9668C92.6403 167.727 93.9969 168.947 93.9969 170.453V172.118Z",
    fill: "#E1E1E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3674 173.083H92.8718",
    stroke: "#CFCFCF",
    strokeWidth: 6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.206 168.304H71.6142V165.491H70.206V168.304Z",
    fill: "#E1E1E1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1274 168.041H82.5356V165.228H81.1274V168.041Z",
    fill: "#E1E1E1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.206 165.94H82.5356V164.381H70.206V165.94Z",
    fill: "#E1E1E1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.361 110.797C80.361 120.443 75.9199 129.203 65.865 129.203C55.81 129.203 51.369 120.443 51.369 110.797C51.369 99.4828 58.9672 88.2314 65.865 88.2314C72.7627 88.2314 80.361 99.4828 80.361 110.797Z",
    fill: "#EEEEEE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.865 108.717V136.186",
    stroke: "#E1E1E1",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1691 121.273L70.0925 117.315",
    stroke: "#E1E1E1",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2868 115.9L61.3632 111.942",
    stroke: "#E1E1E1",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8588 97.9728C79.2173 96.2473 75.7013 96.5394 75.7008 91.728C75.6998 84.4836 86.8059 85.3104 87.4607 79.852C88.1157 74.3937 80.9791 74.5241 80.7582 69.9202C80.5372 65.3162 85.9638 55.8164 94.1971 55.8164C100.689 55.8164 95.3122 63.1465 100.552 66.4244C105.791 69.7024 111.775 65.5029 114.737 70.6575C118.816 77.7578 108.385 86.285 109.414 91.728C110.443 97.1712 116.558 95.8842 116.745 101.865C116.932 107.846 108.049 108.898 108.886 114.026C109.414 117.259 115.035 116.18 115.33 122.554C115.58 127.951 96.2646 134.63 81.755 123.647C67.2453 112.664 82.3073 104.559 79.8588 97.9728Z",
    fill: "#CFCFCF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8507 84.8999V137.942",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1548 120.814L103.742 113.998",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2561 101.399L100.113 97.9346",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4453 109.113L89.3955 103.678",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5849 92.3325L92.6455 89.6919",
    stroke: "#EEEEEE",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.628 98.4265C150.628 110.393 139.829 120.094 126.508 120.094C113.188 120.094 102.389 110.393 102.389 98.4265C102.389 86.4597 113.188 76.7588 126.508 76.7588C139.829 76.7588 150.628 86.4597 150.628 98.4265Z",
    fill: "#EEEEEE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M126.508 92.1646V136.483",
    stroke: "#C4C4C4",
    strokeWidth: 3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M126.508 112.714L131.878 107.89",
    stroke: "#C4C4C4",
    strokeWidth: 3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.711 98.2351L129.476 95.7515",
    stroke: "#C4C4C4",
    strokeWidth: 3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M126.508 105.517L121.363 100.895",
    stroke: "#C4C4C4",
    strokeWidth: 3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.375 162.946H270.615V33.3096H267.375V162.946Z",
    fill: "#DEDEDE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.085 36.6086L208.444 28.9648C207.373 28.6456 206.787 27.5961 207.142 26.6329L208.421 23.163C208.776 22.1998 209.943 21.673 211.014 21.9922L236.655 29.636C237.726 29.9553 238.312 31.0048 237.957 31.9679L236.678 35.4378C236.323 36.401 235.156 36.9279 234.085 36.6086Z",
    fill: "#EEEEEE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.785 211.009H275.205V168.045H262.785V211.009Z",
    fill: "#CFCFCF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.417 176.057H272.572V161.356H265.417V176.057Z",
    fill: "#CFCFCF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.018 36.4085H271.972V30.1753H266.018V36.4085Z",
    fill: "#CFCFCF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M225.392 26.3408C225.392 26.3408 268.995 35.0108 268.995 56.0839",
    stroke: "#E1E1E1",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.948 34.2646L208.839 25.8849C206.323 25.1351 204.948 22.6705 205.781 20.4083L206.034 19.7232C206.868 17.4611 209.608 16.2237 212.124 16.9736L240.233 25.3531C242.748 26.1031 244.124 28.5675 243.29 30.8299L243.037 31.515C242.204 33.7771 239.463 35.0145 236.948 34.2646Z",
    fill: "#CFCFCF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.019 236.479H129.803C130.196 227.382 136.406 223.496 145.877 223.281C152.129 208.039 165.826 223.589 166.812 211.533C167.971 197.354 168.304 180.644 168.304 180.644L176.38 180.764C176.38 180.764 177.054 189.71 178.453 207.937C179.445 220.848 189.554 208.874 202.832 216.698C209.535 220.648 209.236 230.203 209.236 230.203C209.236 230.203 215.019 230.463 215.019 236.479Z",
    fill: "#B1B3B8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.082 236.479H138.18C139.089 232.445 142.971 229.503 147.544 229.099C148.42 229.024 149.322 229.04 150.233 229.159C150.757 229.229 151.268 229.328 151.762 229.459C153.116 229.817 154.344 230.397 155.393 231.144C157.286 232.487 158.606 234.373 159.082 236.479Z",
    fill: "#D7DADD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.538 236.479H194.226C194.69 234.623 196.166 233.119 198.108 232.548C198.566 232.414 199.049 232.33 199.554 232.307C199.843 232.293 200.131 232.3 200.41 232.327C202.875 232.552 204.934 234.232 205.538 236.479Z",
    fill: "#D7DADD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.147 236.479H154.823C154.69 235.33 154.72 234.15 154.931 232.957C155.04 232.337 155.196 231.731 155.392 231.144C157.628 224.498 165.285 220.146 173.433 221.214C175.359 221.468 177.153 222.002 178.769 222.763C184.372 225.397 187.829 230.748 187.147 236.479Z",
    fill: "#D7DADD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.482 210.047C161.217 211.549 159.59 212.581 157.848 212.353C156.106 212.124 154.909 210.721 155.174 209.219C155.439 207.716 157.066 206.684 158.808 206.913C160.55 207.141 161.747 208.544 161.482 210.047Z",
    fill: "#D7DADD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.646 210.568C184.537 211.188 183.865 211.614 183.147 211.52C182.427 211.425 181.933 210.846 182.043 210.226C182.152 209.606 182.824 209.18 183.543 209.274C184.261 209.369 184.756 209.948 184.646 210.568Z",
    fill: "#D7DADD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.524 229.448C222.271 230.878 220.722 231.862 219.063 231.644C217.403 231.426 216.263 230.09 216.516 228.659C216.768 227.228 218.318 226.245 219.977 226.463C221.636 226.68 222.776 228.017 222.524 229.448Z",
    fill: "#D7DADD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.01 175.264H182.305C183.423 175.264 184.33 174.482 184.33 173.518C184.33 172.553 183.423 171.771 182.305 171.771H163.01C161.892 171.771 160.985 172.553 160.985 173.518C160.985 174.482 161.892 175.264 163.01 175.264ZM167.299 182.626H178.016L182.066 175.264H163.249L167.299 182.626Z",
    fill: "#A6A6A6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.402158,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.982 182.626H167.265L163.215 175.264H182.032L177.982 182.626Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M148.651 218.6L144.383 214.438L150.57 207.287L157.998 213.082L155.319 218.17",
    stroke: "#19141E",
    strokeWidth: 4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M194.995 218.256L191.169 213.761L198.059 207.15L204.865 213.533L201.679 218.379",
    stroke: "#19141E",
    strokeWidth: 4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.135 188.247L195.068 168.026",
    stroke: "#19141E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M149.153 187.631L152.387 167.431",
    stroke: "#19141E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.289 176.358H176.558C175.257 176.358 174.202 175.41 174.202 174.24V166.388C174.202 165.218 175.257 164.27 176.558 164.27H185.289C186.59 164.27 187.644 165.218 187.644 166.388V174.24C187.644 175.41 186.59 176.358 185.289 176.358Z",
    fill: "#19141E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.061 176.358H176.558C175.257 176.358 174.202 175.41 174.202 174.24V166.388C174.202 165.218 175.257 164.27 176.558 164.27H183.061C184.362 164.27 185.417 165.218 185.417 166.388V174.24C185.417 175.41 184.362 176.358 183.061 176.358Z",
    fill: "#B8BFD9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.743 173.891C152.682 173.893 152.62 173.893 152.559 173.893C148.5 173.893 145.21 170.935 145.21 167.285C145.21 163.635 148.5 160.676 152.559 160.676C153.425 160.676 154.257 160.811 155.029 161.059C158.651 155.199 165.603 151.234 173.586 151.234C181.201 151.234 187.879 154.842 191.621 160.261C192.364 160.034 193.159 159.911 193.987 159.911C198.045 159.911 201.336 162.87 201.336 166.519C201.336 169.991 198.359 172.837 194.576 173.107C193.074 182.32 184.249 189.393 173.586 189.393C163.229 189.393 154.605 182.719 152.743 173.891ZM139.943 192.14C139.72 189.454 141.96 187.115 144.947 186.914L152.45 186.411C155.436 186.211 158.038 188.225 158.26 190.911L159.537 206.291C159.759 208.977 157.519 211.316 154.533 211.517L147.03 212.02C144.043 212.221 141.442 210.206 141.219 207.52L139.943 192.14ZM194.326 186.08C191.331 186.066 188.891 188.238 188.875 190.931L188.784 206.353C188.768 209.047 191.182 211.241 194.177 211.256L201.701 211.292C204.695 211.306 207.136 209.135 207.152 206.441L207.243 191.019C207.259 188.326 204.844 186.131 201.85 186.116L194.326 186.08Z",
    fill: "#939393"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.485 152.691H181.688V147.873H165.485V152.691Z",
    fill: "#19141E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.061 176.358C184.362 176.358 185.417 175.41 185.417 174.24V166.388C185.417 165.218 184.362 164.27 183.061 164.27H185.289C186.59 164.27 187.645 165.218 187.645 166.388V174.24C187.645 175.41 186.59 176.358 185.289 176.358H183.061Z",
    fill: "#19141E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.401762,
    d: "M152.098 191.443L154.091 191.268L152.098 191.443ZM147.223 187.353L147.048 185.36L147.223 187.353ZM153.445 206.827L151.453 207.002L153.445 206.827ZM149.355 211.703L149.181 209.71H149.181L149.355 211.703ZM144.48 207.612L146.472 207.438L144.48 207.612ZM143.133 192.228L141.14 192.402L143.133 192.228ZM155.437 191.186L157.43 191.012L155.437 191.186ZM150.562 187.096L150.387 185.104H150.387L150.562 187.096ZM156.784 206.571L154.792 206.745L156.784 206.571ZM152.694 211.446L152.519 209.454H152.519L152.694 211.446ZM147.818 207.356L149.811 207.181L147.818 207.356ZM146.471 191.971L144.479 192.146L144.479 192.146L146.471 191.971ZM154.091 191.268C153.778 187.692 150.625 185.047 147.048 185.36L147.397 189.345C148.773 189.225 149.985 190.242 150.106 191.617L154.091 191.268ZM155.438 206.653L154.091 191.268L150.106 191.617L151.453 207.002L155.438 206.653ZM149.529 213.695C153.106 213.382 155.751 210.229 155.438 206.653L151.453 207.002C151.573 208.377 150.556 209.59 149.181 209.71L149.529 213.695ZM142.487 207.787C142.8 211.363 145.953 214.008 149.529 213.695L149.181 209.71C147.805 209.831 146.592 208.813 146.472 207.438L142.487 207.787ZM141.14 192.402L142.487 207.787L146.472 207.438L145.125 192.054L141.14 192.402ZM147.048 185.36C143.472 185.673 140.827 188.826 141.14 192.402L145.125 192.054C145.005 190.678 146.022 189.465 147.397 189.345L147.048 185.36ZM157.43 191.012C157.116 187.436 153.964 184.791 150.387 185.104L150.736 189.088C152.112 188.968 153.324 189.985 153.445 191.361L157.43 191.012ZM158.777 206.396L157.43 191.012L153.445 191.361L154.792 206.745L158.777 206.396ZM152.868 213.439C156.444 213.126 159.09 209.973 158.777 206.396L154.792 206.745C154.912 208.121 153.895 209.333 152.519 209.454L152.868 213.439ZM145.826 207.53C146.139 211.107 149.292 213.752 152.868 213.439L152.519 209.454C151.144 209.574 149.931 208.557 149.811 207.181L145.826 207.53ZM144.479 192.146L145.826 207.53L149.811 207.181L148.464 191.797L144.479 192.146ZM150.387 185.104C146.811 185.417 144.166 188.57 144.479 192.146L148.464 191.797C148.343 190.421 149.361 189.209 150.736 189.088L150.387 185.104Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.397763,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.07 176.351H176.567C175.265 176.351 174.211 175.403 174.211 174.233V166.381C174.211 165.211 175.265 164.263 176.567 164.263H183.07C184.371 164.263 185.426 165.211 185.426 166.381V174.233C185.426 175.403 184.371 176.351 183.07 176.351ZM177.679 169.7C178.621 169.7 179.386 169.012 179.386 168.165C179.386 167.317 178.621 166.63 177.679 166.63C176.737 166.63 175.973 167.317 175.973 168.165C175.973 169.012 176.737 169.7 177.679 169.7ZM182.529 169.7C183.471 169.7 184.235 169.012 184.235 168.165C184.235 167.317 183.471 166.63 182.529 166.63C181.586 166.63 180.822 167.317 180.822 168.165C180.822 169.012 181.586 169.7 182.529 169.7ZM177.679 174.135C178.621 174.135 179.386 173.448 179.386 172.601C179.386 171.753 178.621 171.066 177.679 171.066C176.737 171.066 175.973 171.753 175.973 172.601C175.973 173.448 176.737 174.135 177.679 174.135Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.404204,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.99 167.229C144.99 170.879 148.28 173.838 152.339 173.838C156.397 173.838 159.687 170.879 159.687 167.229C159.687 163.579 156.397 160.62 152.339 160.62C148.28 160.62 144.99 163.579 144.99 167.229Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.398763,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.024 190.966L188.933 206.389C188.917 209.082 191.331 211.277 194.326 211.291L201.85 211.327C204.844 211.342 207.285 209.17 207.301 206.477L207.392 191.054C207.408 188.361 204.993 186.166 201.999 186.152L194.475 186.116C191.481 186.101 189.04 188.273 189.024 190.966Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.397856,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.565 160.333C192.307 160.106 193.103 159.983 193.93 159.983C197.989 159.983 201.279 162.942 201.279 166.592C201.279 170.063 198.303 172.909 194.52 173.179C194.669 172.268 194.746 171.335 194.746 170.386C194.746 166.697 193.581 163.252 191.565 160.333H191.565Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.598121,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.679 174.134C178.621 174.134 179.386 173.447 179.386 172.599C179.386 171.752 178.621 171.064 177.679 171.064C176.737 171.064 175.973 171.752 175.973 172.599C175.973 173.447 176.737 174.134 177.679 174.134Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M186.699 136.605V123.885",
    stroke: "#19141E",
    strokeWidth: 4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.972 142.004H182.124V134.165H187.972C190.369 134.165 192.33 135.928 192.33 138.084C192.33 140.24 190.369 142.004 187.972 142.004Z",
    fill: "#19141E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.564 121.39C183.766 119.994 185.093 118.917 186.699 118.917C188.446 118.917 189.862 120.19 189.862 121.761C189.862 123.332 188.446 124.605 186.699 124.605C185.422 124.605 184.321 123.924 183.822 122.943L181.617 121.426L178.616 123.491L175.617 121.426L172.618 123.491L169.619 121.426L166.619 123.491L164.964 122.351C164.662 123.639 163.391 124.605 161.87 124.605C160.123 124.605 158.707 123.332 158.707 121.761C158.707 120.19 160.123 118.917 161.87 118.917C163.293 118.917 164.497 119.763 164.894 120.927L166.619 122.115L169.619 120.05L172.618 122.115L175.617 120.05L178.616 122.115L181.617 120.05L183.564 121.39ZM185.557 147.796H162.794C160.981 147.796 159.512 146.475 159.512 144.845V131.323C159.512 129.693 160.981 128.371 162.794 128.371H185.557C187.369 128.371 188.838 129.693 188.838 131.323V144.845C188.838 146.475 187.369 147.796 185.557 147.796ZM164.915 150.473H183.435C184.257 150.473 184.923 149.874 184.923 149.135C184.923 148.396 184.257 147.797 183.435 147.797H164.915C164.094 147.797 163.427 148.396 163.427 149.135C163.427 149.874 164.094 150.473 164.915 150.473Z",
    fill: "#A6A6A6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.404367,
    d: "M169.619 121.426L166.619 123.491L164.964 122.362L164.886 120.922L166.619 122.115L169.619 120.05L172.618 122.115L175.617 120.05L178.616 122.115L181.617 120.05L183.537 121.426L183.856 122.953L181.617 121.426L178.616 123.491L175.617 121.426L172.618 123.491L169.619 121.426Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.395624,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.435 150.474H164.915C164.094 150.474 163.427 149.874 163.427 149.135C163.427 148.396 164.094 147.797 164.915 147.797H183.435C184.257 147.797 184.923 148.396 184.923 149.135C184.923 149.874 184.257 150.474 183.435 150.474Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.461 142.004H164.309V134.165H158.461C156.064 134.165 154.103 135.928 154.103 138.084C154.103 140.24 156.064 142.004 158.461 142.004Z",
    fill: "#19141E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.699 138.084C186.699 141.081 184.541 143.511 181.878 143.511C179.215 143.511 177.057 141.081 177.057 138.084C177.057 135.086 179.215 132.656 181.878 132.656C184.541 132.656 186.699 135.086 186.699 138.084Z",
    fill: "#19141E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.612 143.511H181.878V132.656H179.612V143.511Z",
    fill: "#19141E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.434 138.084C184.434 141.081 182.275 143.511 179.612 143.511C176.95 143.511 174.791 141.081 174.791 138.084C174.791 135.086 176.95 132.656 179.612 132.656C182.275 132.656 184.434 135.086 184.434 138.084Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.08 137.72C182.08 138.775 181.321 139.63 180.383 139.63C179.446 139.63 178.686 138.775 178.686 137.72C178.686 136.665 179.446 135.809 180.383 135.809C181.321 135.809 182.08 136.665 182.08 137.72Z",
    fill: "#19141E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M161.87 136.605V124.471",
    stroke: "#19141E",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLogo);
export default __webpack_public_path__ + "static/media/emptyLogo.bc2a92b42b5661308296d7a7c879e0e9.svg";
export { ForwardRef as ReactComponent };